<template>
    <div class="jc-navbar-wrapper" :style="{zIndex: zIndex}" :class="{'fixed': fixed}">
        <div class="jc-navbar">
            <div class="jc-navbar-item jc-navbar-left"
            v-if="showLeft" @click.stop="handleLeftClick">
                <i class="jc-icon icon-arrow-left arrow" v-if="arrow"></i><span class="left-text">{{leftText}}<slot name="left"/></span>
            </div>
            <div class="jc-navbar-item jc-navbar-center"><span>{{title}}</span></div>
            <div class="jc-navbar-item jc-navbar-right" v-if="showRight">{{rightText}}<slot name="right"/></div>
        </div>
    </div>
</template>

<script>
import routerLink from '@/utils/mixins/router-link'
export default {
  name: 'jc-navbar',
  mixins: [routerLink],
  props: {
    title: String,
    leftText: String,
    rightText: String,
    showLeft: {
      type: Boolean,
      default: true
    },
    showRight: {
      type: Boolean,
      default: true
    },
    fixed: Boolean, // 是否固定布局
    zIndex: {
      type: [Number, String],
      default: 899
    },
    arrow: {
      type: Boolean,
      default: true
    },
    goBackFunction: Function
  },
  methods: {
    handleLeftClick () {
      if (this.url || this.to || this.goBack) {
        this.routerLink()
      } else if (this.goBackFunction) {
        this.goBackFunction()
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/variable.scss';
@import '@/assets/scss/mixins.scss';
.jc-navbar-wrapper {
    position: relative;
    &.fixed {
        position: fixed;
        width: 100%;
        top: 0;
        left: 0;
        z-index: 899;
    }
}
.jc-navbar {
    width: 100%;
    height: 70px;
    display: flex;
    background: #EBEAEA;
    align-items: center;
    overflow: hidden;
    position: relative;
    &-item {
        display: flex;
        // justify-content: center;
        align-items: center;
        height: 100%;
        overflow: hidden;
        &.jc-navbar-left {
            // min-width: 54px;
            padding: 0 18px;
            position: absolute;
            left: 0;
            top: 0;
            .arrow {
                font-size: 32px;
                font-weight: bold;
            }
            .left-text {
                font-size: 30px;
                color: $black_text;
                margin-left: 10px;
            }
        }
        &.jc-navbar-center {
            // flex: 1;
            width: 60%;
            margin: 0 auto;
            justify-content: center;
            font-size: 34px;
            color: $black_text;
            span {@include nowrap;}
        }
        &.jc-navbar-right {
            min-width: 80px;
            position: absolute;
            right: 0;
            top: 0;
            font-size: 30px;
            color: $black_text;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/navbar/index.vue